import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer, toast } from "react-toastify";

import Config from "config";
const ClonePMEPage = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("auth_token_" + api);
  const [pmeData, setPmeData] = useState();
  const [pmeToClone, setPmeToClone] = useState(pmeData?.sil);
  const [numPMEs, setNumPMEs] = useState("");
  const [rootName, setRootName] = useState("");
  const [firstNumber, setFirstNumber] = useState("");
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState("details");
  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/pmes/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const pmeData = await response.json();
        setPmeData(pmeData);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Duplication
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    document.getElementById("submit").disabled = true;
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/pmes/cloner`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            pme: {
              pme_id: id,
              nb: numPMEs,
              racine: rootName,
              numero: firstNumber,
            },
          }),
        }
      );
      const responseData = await response.json();
      console.log(responseData);
      console.log("HIIIIII");
      if (response.ok) {
        console.log(responseData);
        console.log("HIIIIII");
        toast.success(responseData.message);
      } else {
        if (responseData) {
          console.log("HIIIIII");
          toast.error(responseData.message);
        } else {
          console.error("Une erreur s'est produite");
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.log("An error occurred", error);
      console.error("Une erreur s'est produite");
      toast.error("Une erreur s'est produite");
    }
  };
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/pmes/${id}`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        PME
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        pmeData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end"></div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <div>
                                <Form onSubmit={handleSubmit}>
                                  <FormGroup>
                                    <Label for="pmeToClone">
                                      PME à cloner :
                                    </Label>
                                    <Input
                                      type="text"
                                      id="pmeToClone"
                                      value={pmeData.sil}
                                      className="form-control"
                                      readOnly
                                    />
                                  </FormGroup>
                                  <FormGroup>
                                    <Label for="numPMEs">
                                      Nb de PME à créer :
                                    </Label>
                                    <Input
                                      type="number"
                                      id="numPMEs"
                                      value={numPMEs}
                                      onChange={(e) =>
                                        setNumPMEs(e.target.value)
                                      }
                                    />
                                  </FormGroup>
                                  <FormGroup>
                                    <Label for="rootName">
                                      Racine du nom :
                                    </Label>
                                    <Input
                                      type="text"
                                      id="rootName"
                                      value={rootName}
                                      onChange={(e) =>
                                        setRootName(e.target.value)
                                      }
                                    />
                                  </FormGroup>
                                  <FormGroup>
                                    <Label for="firstNumber">
                                      Premier numéro :
                                    </Label>
                                    <Input
                                      type="number"
                                      id="firstNumber"
                                      value={firstNumber}
                                      onChange={(e) =>
                                        setFirstNumber(e.target.value)
                                      }
                                    />
                                  </FormGroup>
                                  <Button
                                    color="primary"
                                    type="submit"
                                    id="submit"
                                  >
                                    Dupliquer
                                  </Button>
                                </Form>
                              </div>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default ClonePMEPage;
